/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-kno2
 * Kno2 Document Fetcher API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProcessDocumentsRequest
 */
export interface ProcessDocumentsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ProcessDocumentsRequest
     */
    document_ids: Array<string>;
}

/**
 * Check if a given object implements the ProcessDocumentsRequest interface.
 */
export function instanceOfProcessDocumentsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "document_ids" in value;

    return isInstance;
}

export function ProcessDocumentsRequestFromJSON(json: any): ProcessDocumentsRequest {
    return ProcessDocumentsRequestFromJSONTyped(json, false);
}

export function ProcessDocumentsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProcessDocumentsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'document_ids': json['document_ids'],
    };
}

export function ProcessDocumentsRequestToJSON(value?: ProcessDocumentsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'document_ids': value.document_ids,
    };
}

